module.exports = {
  dynamic: (data, page) => {
    if (!data) throw new Error("Requires data")

    const typeName = data.__typename.replace("Contentful", "")

    switch (typeName) {
      case "Article":
        return module.exports.article(data)
      case "Author":
        return module.exports.author(data)
      case "Expert":
        return module.exports.expert(data)
      case "Campaign":
        return module.exports.campaign(data)
      case "Download":
        return module.exports.download(data)
      case "Desk":
        return module.exports.desk(data, page)
      case "DeskCategory":
        return module.exports.deskCategory(data, page)
      case "Tag":
        return module.exports.tag(data, page)
      case "Tool": // when does this happen?
        return module.exports.tool(data)
      case "Outgrow":
        return module.exports.tool(data)
      case "ProductBeta":
        return module.exports.product(data)
      case "Page":
        return module.exports.page(data)
      case "ExternalLink":
        return data.url
      default:
        throw new Error(`Unsupported type: ${typeName}`)
    }
  },
  article: (data) => {
    if (!data) throw new Error("Requires article data")
    // let's check if we have the hero/hub/help slug2 scheme
    if (
      data.slug2 &&
      Array.isArray(data.categories) &&
      data.categories[0]?.desk?.slug2 &&
      Array.isArray(data.categories) &&
      data.categories[0].slug2
    ) {
      return `/${data.categories[0]?.desk?.slug2}/${data.categories[0].slug2}/${data.slug2}`
    }
    // else keep using old scheme
    let id = "1"
    if (data.legacyId) id = data.legacyId
    return `/${id}/${data.slug}.htm`
  },

  author: (data) => {
    if (!data) throw new Error("Requires author data")
    return `/auteur/${data.slug}`
  },

  expert: (data) => {
    if (!data) throw new Error("Requires expert data")
    return `/expert/${data.slug}`
  },

  campaign: (data) => {
    if (!data) throw new Error("Requires campaign data")
    return `/thema/${data.slug}`
  },

  download: (data) => {
    if (!data) throw new Error("Requires download data")
    data.downloadType = data.downloadType || "whitepaper"
    return `/${data.downloadType.toLowerCase()}/${data.slug}`
  },

  desk: (data, page) => {
    if (!data) throw new Error("Requires desk data")
    // let's check if we have the hero/hub/help slug2 scheme
    if (data.slug2 && page && page !== 1) return `/${data.slug2}/pagina/${page}`
    else if (data.slug2) return `/${data.slug2}`
    // else use old scheme
    let id = "1"
    if (data.legacyId) id = data.legacyId
    if (page && page !== 1) return `/${data.slug}/${id}/pagina/${page}/`
    return `/${data.slug}/${id}.htm`
  },

  deskCategory: (data, page) => {
    if (!data) throw new Error("Requires deskCategory data")
    let id = "1"
    // let's check if we have the hero/hub/help slug2 scheme
    if (data.slug2 && data.desk?.slug2 && page && page !== 1)
      return `/${data.desk.slug2}/${data.slug2}/pagina/${page}`
    else if (data.slug2 && data.desk?.slug2)
      return `/${data.desk.slug2}/${data.slug2}`
    // else use old scheme
    if (data.legacyId) id = data.legacyId
    if (page && page !== 1) return `/${data.slug}/${id}/pagina/${page}/`
    return `/${data.slug}/${id}.htm`
  },

  partner: (data) => {
    if (!data) throw new Error("Requires partner data")
    return `/${data.slug}`
  },

  tag: (data, page) => {
    if (!data) throw new Error("Requires tag data")
    let id = "1"
    if (data.legacyId) id = data.legacyId
    if (page && page !== 1) return `/dossier/${id}/${data.slug}/pagina/${page}/`
    return `/dossier/${id}/${data.slug}.htm`
  },

  tool: (data) => {
    if (!data) throw new Error("Requires tool data")
    return `/tool/${data.slug}`
  },

  product: (data) => {
    if (!data) throw new Error("Requires product data")
    const productType = data.productType ?? "product"
    return `/${productType}/${data.slug}`
  },

  page: (data) => {
    if (!data) throw new Error("Requires page data")
    return `/${data.slug}`
  },
}
